module.exports = __webpack_public_path__ + "static/media/polyledger.393a4bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/polyledger.png
// module id = 88
// module chunks = 0